import React from "react";
import MutationTable from "../../../../../components/MutationTable";
import type {
  ChildSummary,
  DecoratedMutationRequest,
  EntityId,
  FamilySummary,
  LookupMap,
  ParentSummary,
  UserSummary,
} from "../types/mutationRequests.types";

interface MutationRequestsContentProps {
  pending: DecoratedMutationRequest[];
  history: DecoratedMutationRequest[];
  canProcess: boolean;
  canDelete: boolean;
  processingRequestId: EntityId | null;
  userLookup: LookupMap<UserSummary>;
  parentLookup: LookupMap<ParentSummary>;
  childLookup: LookupMap<ChildSummary>;
  familyLookup: LookupMap<FamilySummary>;
  initialRequestId?: string | null;
  onApprove: (id: EntityId) => Promise<void>;
  onReject: (id: EntityId) => Promise<void>;
  onRestore: (id: EntityId) => Promise<void>;
  onDelete: (id: EntityId) => void;
}

export const MutationRequestsContent = ({
  pending,
  history,
  canProcess,
  canDelete,
  processingRequestId,
  userLookup,
  parentLookup,
  childLookup,
  familyLookup,
  initialRequestId,
  onApprove,
  onReject,
  onRestore,
  onDelete,
}: MutationRequestsContentProps) => (
  <section
    aria-label="Mutation requests"
    className="overflow-hidden rounded-[20px] bg-transparent"
  >
    <MutationTable
      requests={[...pending, ...history]}
      showStatus
      showActions={canProcess || canDelete}
      onApprove={canProcess ? onApprove : undefined}
      onReject={canProcess ? onReject : undefined}
      onRestore={canProcess ? onRestore : undefined}
      onDelete={canDelete ? onDelete : undefined}
      processingRequestId={processingRequestId}
      userLookup={userLookup}
      parentLookup={parentLookup}
      childLookup={childLookup}
      familyLookup={familyLookup}
      initialRequestId={initialRequestId}
    />
  </section>
);
